// extracted by mini-css-extract-plugin
export default {"container":"LoaderSection_container__HHwqP"};